import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromConfig from './config';
import { fromDebugFlags } from './reducers';
import { DebugFlagEffects } from './effects/debug-flag.effects';
import { DebugFlagsService, DebugFlagsStorageService } from './services';
import { IfDebugFlagDirective } from './directives/if-debug-flag.directive';
import { IfDebugFlagAsyncDirective } from './directives/if-debug-flag-async.directive';
import { IfNotDebugFlagDirective } from './directives/if-not-debug-flag.directive';
import { IfNotDebugFlagAsyncDirective } from './directives/if-not-debug-flag-async.directive';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import * as i0 from "@angular/core";
export function environmentFactory() {
    return Configuration.isProductionEquivalentEnvironment();
}
export class DevelopmentModule {
    static forRoot(flags = []) {
        return {
            ngModule: DevelopmentModule,
            providers: [
                {
                    provide: fromConfig.DebugFlagList,
                    multi: true,
                    useValue: flags
                },
                { provide: fromConfig.DevelopmentModuleProdEnvironment, useFactory: environmentFactory }
            ]
        };
    }
    static withFlags(flags = []) {
        return {
            ngModule: DevelopmentModule,
            providers: [
                {
                    provide: fromConfig.DebugFlagList,
                    multi: true,
                    useValue: flags
                }
            ]
        };
    }
    static { this.ɵfac = function DevelopmentModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DevelopmentModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DevelopmentModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            DebugFlagsService,
            DebugFlagEffects,
            DebugFlagsStorageService,
            {
                provide: fromConfig.DebugFlagList,
                multi: true,
                useValue: fromConfig.GlobalDebugFlags
            }
        ], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            StoreModule.forFeature('debugFlags', fromDebugFlags.debugFlagsReducer),
            EffectsModule.forFeature([DebugFlagEffects])] }); }
}
//# sourceMappingURL=development.module.js.map